// Screen-level state machine. Exactly one scene is active at a time.
// Scenes get update/render from the game loop and own any DOM they mount.

export interface Scene {
  enter(): void | Promise<void>;
  exit(): void | Promise<void>;
  update(dt: number): void;
  render(ctx: CanvasRenderingContext2D): void;
}

export class SceneManager {
  private current: Scene | null = null;
  private transitioning = false;

  async transition(next: Scene): Promise<void> {
    if (this.transitioning) return;
    this.transitioning = true;
    try {
      if (this.current) await this.current.exit();
      this.current = next;
      await next.enter();
    } finally {
      this.transitioning = false;
    }
  }

  update(dt: number): void {
    if (this.transitioning) return;
    this.current?.update(dt);
  }

  render(ctx: CanvasRenderingContext2D): void {
    if (this.transitioning) return;
    this.current?.render(ctx);
  }

  get activeScene(): Scene | null {
    return this.current;
  }
}
